import { commonLocales } from "src/locales/commonLocales";

export const JOB_CONSTANTS = {
  Action: "actions",
  ACTIONS: {
    ACTION: "action",
    CANCEL: "cancel",
    EDIT: "edit",
    UPDATE: "update",
    DELETE: "delete",
  },
  ADD_JOB: "add-job",
  DUPLICATE_FROM: "duplicateFrom",
  ADDRESS: "address",
  ADDRESS_KEY_INDEX: 14,
  ADMIN_JOB_CANCEL_TYPE: 3,
  API_INDEX_KEY_SINGLE_DAY: 1,
  API_INDEX_VALUE_MULTI_DAY: 2,
  APPLICANT_STATUS: 4,
  APPLY_BEFORE_INDEX: 15,
  ASSIGN: {
    MULTIPLE: "multiple",
    SINGLE: "single",
  },
  ASSIGN_PROFESSIONAL: ["Shortlisted", "Assigned"],
  BILL_RATE: "billRate",
  BILL_PAY_RATE: 2,
  DATES: "dates",
  DNS: "dns",
  DNS_PROFESSIONAL: "dns_professional",
  BILL_RATE_FLAG: true,
  BILL_RATE_KEY_INDEX: 13,
  CANCELLED: 5,
  CANCELLED_BY_STATUS: {
    ADMIN: 3,
    OFFICE: 1,
    PROFESSIONAL: 2,
  },
  CAROUSEL_DIVIDE_WIDTH: 2,
  CONTRACT: 1,
  CONTRACT_LIST: [1],
  CONTRACT_HIRE: "Contract hire",
  CREATE_JOB_FORM_FIELDS: {
    DUE_DATE: "due_date",
    EXPECTED_JOIN_DATE: "expected_joining_date",
    JOB_ROLE: "jobRole",
    JOB_TYPE: "jobType",
    JOB_OVERVIEW: "jobOverview",
    OFFICE: "office",
    PAY_ROLL_RATE: "payRollRate",
    PLACEMENT_TYPE: "placementType",
    SERVICE_TYPE: "type",
  },
  DATE_FORMAT: "MM-DD-YYYY",
  DATE_HOURS_FORMAT: "HH:mm:ss",
  DATE_ICON_POSITION: "bottom-start",
  DATE_SEPARATOR_DASH: "-",
  DATE_SHIFT_TIME_FORMAT: "hh:mm A",
  DAY_INDEX: 0,
  DAY_TYPE: {
    DENTIST: "Dentist",
    SINGLE_DAY: 1,
    MULTIPLE_DAY: 2,
  },
  DECIMAL_INDEX: 2,
  DEFAULT_PAY_VALUE: "0",
  DEFAULT_END_TIME: "00:00 PM",
  DEFAULT_LUNCH_END_TIME: "01:00 PM",
  DEFAULT_LUNCH_START_TIME: "12:00 PM",
  DEFAULT_MIN_PAY: 0,
  DEFAULT_MAX_PAY: 100,
  DEFAULT_START_TIME: "00:00 AM",
  DEFAULT_TIME: "00:00",
  DENTIST: "Dentist",
  DEFAULT_INDEX: 0,
  DIGIT_PADDING_LENGTH: 2,
  DIRECT: 0,
  DIRECT_HIRE: "Direct Hire",
  DOLLAR: "$",
  DROPDOWN_RANGE_VALUES: {
    FIFTH_LABEL_FIFTY_MILES: "50 miles",
    FIRST_LABEL_FIVE_MILES: "5 miles",
    FOURTH_LABEL_THIRTY_MILES: "30 miles",
    SECOND_LABEL_TEN_MILES: "10 miles",
    THIRD_LABEL_TWENTY_MILES: "20 miles",
    SIXTH_LABEL_SIXTY_MILES: "60 miles",
    SEVENTH_LABEL_SEVENTY_MILES: "70 miles",
  },
  DUE_DATE_FORMAT: "YYYY-MM-DDTHH:mm:ss+00:00",
  EDIT_JOB: "edit-job",
  EMAIL: "email",
  EMPTY_SEPARATOR: "-",
  FILL_STRING: "0",
  HOUR: 24,
  ID: "id",
  IMAGE_SIZE: 30,
  IS_JOB: "YES",
  JOB_APPLICANT_STATUS: [
    { TYPE: "warning", VALUE: "SHORTLISTED" },
    { TYPE: "success", VALUE: "ASSIGNED" },
    { TYPE: "dd-completed", VALUE: "COMPLETED" },
    { TYPE: "danger", VALUE: "CANCELLED" },
    { TYPE: "danger", VALUE: "FULFILLED" },
  ],
  JOB_CANCEL_REASONS: "job_cancel_reasons",
  JOB_CANCEL_OTHER_REASON: "7288d050-b216-432f-b435-53d1fa1ec4b0",
  JOB_CANCEL_OFFICE_OTHER_REASON: "182a8379-ff8c-402a-aa19-d40a20d63c61",
  JOB_DATES: "job_dates",
  JOB_KEY_ID_INDEX: 0,
  JOB_KEY_VALUE: "number",
  JOB_START_INDEX: 1,
  JOB_STATUS: [
    {
      TYPE: "dd-open",
      VALUE: commonLocales.job.jobStatus.open,
    },
    {
      TYPE: "dd-published",
      VALUE: commonLocales.job.jobStatus.published,
    },
    {
      TYPE: "dd-hired",
      VALUE: commonLocales.job.jobStatus.hired,
    },
    {
      TYPE: "dd-completed",
      VALUE: commonLocales.job.jobStatus.completed,
    },
    {
      TYPE: "dd-cancelled",
      VALUE: commonLocales.job.jobStatus.cancelled,
    },
    {
      TYPE: "dd-rejected",
      VALUE: commonLocales.job.jobStatus.rejected,
    },
    {
      TYPE: "dd-unfilled",
      VALUE: commonLocales.job.jobStatus.unfilled,
    },
  ],
  JOB_PENDING: "1",
  JOB_STATUS_STYLE: {
    1: "dd-open",
    2: "dd-published",
    3: "dd-hired",
    4: "dd-completed",
    5: "dd-cancelled",
    6: "dd-rejected",
    7: "dd-unfilled",
  },
  JOB_PROFESSIONAL_STATUS_STYLE: {
    1: "dd-published",
    2: "dd-hired",
    3: "dd-completed",
    4: "dd-cancelled",
    5: "dd-hired",
  },
  JOB_CALENDAR_LEGENDS: [
    { id: 1, name: "Pending", className: "dd-open" },
    { id: 2, name: "Open", className: "dd-published" },
    { id: 3, name: "Filled", className: "dd-hired" },
    { id: 4, name: "Completed", className: "dd-completed" },
    { id: 5, name: "Cancelled", className: "dd-cancelled" },
    { id: 6, name: "Rejected", className: "dd-rejected" },
    { id: 7, name: "Unfilled", className: "dd-unfilled" },
  ],
  PROFESSIONAL_CALENDAR_LEGENDS: [
    { id: 1, name: "Assigned", className: "dd-hired" },
    { id: 2, name: "Completed", className: "dd-completed" },
    { id: 3, name: "Cancelled", className: "dd-cancelled" },
  ],
  JOB_STATUSES: { CANCELLED: 5, COMPLETED: 4, UNFILLED: 7, REJECTED: 6 },
  JOB_STATUS_TYPES: {
    CANCELLED: "cancelled",
    REJECTED: "rejected",
    PENDING: "pending",
    COMPLETED: "completed",
    UNFILLED: "unfilled",
  },
  JOB_TIMESHEET_STATUS: [
    { TYPE: "warning", VALUE: commonLocales.job.timesheetStatus.pending },
    { TYPE: "info", VALUE: commonLocales.job.timesheetStatus.submitted },
    { TYPE: "success", VALUE: commonLocales.job.timesheetStatus.approved },
    { TYPE: "danger", VALUE: commonLocales.job.timesheetStatus.rejected },
    { TYPE: "danger", VALUE: commonLocales.job.timesheetStatus.cancelled },
    { TYPE: "warning", VALUE: commonLocales.job.timesheetStatus.disputed },
  ],
  JOB_TYPE: {
    MULTI_DAY: "2",
    SINGLE_DAY: "1",
  },
  JOB_TYPE_KEY_INDEX: 6,
  JOB_CREATED_BY_KEY: 7,
  JOB_CREATED_BY: "created_by_user",
  JOIN_DATE_INDEX: 5,
  LEFT_RIGHT_BUTTON: 32,
  LOGS: {
    ACTION_TYPE: {
      CREATE: 1,
      EDIT: 2,
      PUBLISHED: 3,
      ASSIGNED: 4,
      UNASSIGNED: 5,
      CANCELLED: 6,
      REJECT: 7,
      DELETE: 8,
      DEACTIVATE: 9,
      DISABLE: 10,
      SHIFT_TIME_EDIT: 11,
      ADMIN_TIMESHEET_ADD: 12,
      ADMIN_TIMESHEET_APPROVED: 14,
      ADMIN_TIMESHEET_EDIT: 13,
      ADMIN_TIMESHEET_EDIT_AFTER_APPROVE: 16,
      ADMIN_TIMESHEET_REJECTED: 15,
      RECRUITER_ASSIGN: 17,
      RECRUITER_UN_ASSIGN: 18,
      AUTO_PUBLISHED: 19,
      PUBLISHED_WITH_PAY_RANGE: 20,
    },
  },
  OFFICE_KEY_INDEX: 2,
  OVERVIEW: "overview",
  OVERVIEW_KEY_INDEX: 8,
  LAST_INDEX: 1,
  MAX_HOURS: "12",
  MAX_MIN: "59",
  MAX_PAY: 80,
  MAX_PAY_RATE_INDEX: 1,
  MIN_PAY_RATE_INDEX: 0,
  MOBILE: "mobile",
  MIN_MINITUES: "0",
  MIN_HOURS: "1",
  MIN_PAY: 35,
  MINUTE: 60,
  MONTH_INDEX_ADJUSTMENT: 1,
  MULTIPLE: "multiple",
  MULTIPLE_DAY: "Multiple day",
  MULTIPLE_DAY_INDEX: 2,
  NAME_Of_PROFESSIONAL: "nameOfProfessional",
  NOT_AVAILABLE_VALUE: "NA",
  NOT_MULTI_DAY: "notMultiDay",
  NOT_VALUE: -1,
  PAGE_DEFAULT_LIMIT: [10, 20, 50],
  PAY_RANGE_KEY_INDEX: 11,
  PAY_RATE: "payRate",
  PAY_SCALE: "payScale",
  PAY_SCALE_KEY_INDEX: 12,
  PER_MONTH: 1,
  PHOTO: "photo",
  PLACEMENT_KEY_INDEX: 4,
  PLACEMENT_TYPE: {
    CONTRACT: 1,
    DIRECT: 2,
  },
  POST_CONTRACTS_DATE_UTC_FORMAT: "YYYY-MM-DD hh:mm A",
  POST_CONTRACTS_DATETIME_UTC_OFFSET_FORMAT: "YYYY-MM-DDTHH:mm:ssZ",
  POST_CONTRACT_JOB_TIME_FORMAT: "hh:mm A",
  PROFESSIONAL: {
    ASSIGNED_STATUS: 2,
    FULFILLED: 5,
    CANCELLED: 4,
    COMPLETED: 3,
  },
  PROFESSIONAL_START_INDEX: 1,
  PROFESSIONAL_STATUSES: [
    { TYPE: "warning", VALUE: "Incomplete" },
    { TYPE: "secondary", VALUE: "Submitted" },
    { TYPE: "secondary", VALUE: "In Review" },
    { TYPE: "success", VALUE: "Active" },
    { TYPE: "danger", VALUE: "Inactive" },
  ],
  PAYROLL_KEY: "2",
  RANGE: "range",
  REFERRAL_KEY: "3",
  RESET_KEYWORD: "reset",
  SEPARATOR_BETWEEN_TWO_VALUE: " : ",
  SHOW_DROP_DOWN: true,
  SINGLE_DAY: "Single day",
  SINGLE_DAY_FLAG: 1,
  SKILLS: "skills",
  OTHER_SKILLS: "otherSkills",
  SKILLS_KEY_INDEX: 9,
  OTHER_SKILLS_KEY_INDEX: 10,
  SPLIT_DOLLAR_VALUE: 1,
  STATUS: "status",
  STEP_SLIDER: 2,
  STRING_MAX_LENGTH: 2,
  TAB: {
    FIRST_TAB: 0,
    SECOND_TAB: 1,
    THIRD_TAB: 2,
    FOURTH_TAB: 3,
    FIFTH_TAB: 4,
  },
  TABLE_ROW_SELECT_ACTIVE: "Active",
  TFI_ICON: 30,
  TFI_ICON_LARGE: 60,
  TIME: "timing",
  TIME_CONVERT_DOUBLE_DIGIT: 10,
  TIME_FORMAT: "hh:mm a",
  TIME_DATA: {
    AM: "AM",
    CONVERT_AM_PM: 10,
    DAY_INDEX: 1,
    DIGIT_TYPE: "2-digit",
    HOUR_INDEX: 0,
    MINUTE_INDEX: 1,
    MONTH_INDEX: 0,
    PM: "PM",
    TIME_LANGUAGE: "en-US",
    TWELVE_HOUR: 12,
    YEAR_INDEX: 2,
  },
  TIME_KEY: "time",
  TIME_SEPARATE_HOUR: 0,
  TIME_SEPARATE_MINUTE: 1,
  TIME_SEPARATOR: ":",
  TIME_SEPARATOR_DASH: "-",
  TIME_SEPARATOR_DOT: ".",
  TWO_DIGIT_PADDING_LENGTH: -2,
  TYPE_KEY_INDEX: 3,
  RESET_TYPE_CLEAR: "CLEAR",
  ROLE_KEY_INDEX: 1,
  USER_ID: "user_id",
  UTC_OFFSET: "+00:00",
  UUID: "uuid",
  VALID_CREATE_FORM: true,
  YEAR_INDEX: 2,
  ZERO_PAD_CHARACTER: "0",
  STATE: "state",
  ZIP: "zip",
  PROSPECT: {
    FIRST_NAME: "first_name",
    LAST_NAME: "last_name",
    STAFF_ID: "staff_id",
    TYPE: "type",
    ZIP_CODE: "zip_code",
  },
  ADD_EDIT_JOB_OFFICE_SELECTED_ACTION: "Action",
};
